import keys from "lodash/keys";
export function converToUrlParam(obj) {
    var str = keys(obj)
        .map(function (key) { return key + "=" + obj[key]; })
        .join("&");
    return str;
}
export function parseParamToObj(obj) {
    if (!obj)
        return;
    var str = obj.search;
    if (!str) {
        str = obj.hash;
    }
    var index = str.indexOf("?");
    str = str.substring(index + 1);
    var result = {};
    var paramArray = str.split("&");
    for (var i = 0, len = paramArray.length; i < len; i++) {
        var pair = paramArray[i].split("=");
        if (pair[1] === "") {
            pair.push("");
        }
        result[pair[0]] = pair[1];
    }
    return result;
}
export function checkUrl(str) {
    if (!str)
        return false;
    var reg = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/;
    return reg.test(str);
}
export function parseToHttps(url) {
    if (!url)
        return "";
    if (!/^(http:|https:)?\/\//.test(url)) {
        return "https://" + url;
    }
    return url.replace(/^(http:|https:)?(?=\/\/)/i, "https:");
}
export function getMetaTag(name) {
    var meta = document.head.querySelector("[name=" + name + "]");
    if (meta) {
        return meta.content;
    }
    return "";
}
export default {
    converToUrlParam: converToUrlParam,
    parseParamToObj: parseParamToObj,
    checkUrl: checkUrl,
    parseToHttps: parseToHttps,
    getMetaTag: getMetaTag,
};
//# sourceMappingURL=url.js.map